import $ from 'jquery';

export default {
	init() {
		$(function () {
			// Select all anchor links that point to an ID on the same page
			$('a[href*="#"]:not([href="#"],[href*="fancybox-lightbox"])').on(
				'click',
				function (event) {
					// Ensure the link is for an internal anchor
					if (
						location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
						location.hostname == this.hostname
					) {
						var target = $(this.hash); // Get the target element using the hash
						target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Fallback for name attribute
						if (target.length) {
							// event.preventDefault(); // Prevent default jump behavior
							var offset = 150; // Define your desired offset (e.g., height of a sticky header)
							$('html, body').animate(
								{
									scrollTop: target.offset().top - offset, // Calculate scroll position with offset
								},
								250
							); // Set the duration of the smooth scroll in milliseconds
						}
					}
				}
			);
			$(window).on('load', function () {
				// If there's a hash in the URL on page load, scroll to it with offset
				if (window.location.hash) {
					var target = $(window.location.hash);
					target = target.length
						? target
						: $('[name=' + window.location.hash.slice(1) + ']');
					if (target.length) {
						var offset = 150; // Define your desired offset
						$('html, body').animate(
							{
								scrollTop: target.offset().top - offset,
							},
							250
						);
					}
				}
			});
		});
	},
};
